import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModuleSharedComponentModule } from "@root/router/component/module-shared-component.module";
import { ChannelSharedComponentsModule } from "@root/router/channel/channel-shared-components.module";
import { CalendarSharedComponentsModule } from "@root/router/calendar/calendar-shared-components.module";

@NgModule({
    imports: [CommonModule, ModuleSharedComponentModule, ChannelSharedComponentsModule, CalendarSharedComponentsModule],
    exports: [],
    declarations: []
})
export class PagesModule {
  constructor() {}
}
